export default {
  'gift.name': 'Quà tặng',
  //Ranking gifts list
  'gift.ranking.title': 'Danh sách quà tặng xếp hạng',
  'gift.ranking.tab': 'Quà tặng xếp hạng',

  'gift.ranking.order': 'Thứ tự giải thưởng',
  'gift.ranking.id': 'Mã quà tặng',
  'gift.ranking.name': 'Tên quà tặng',
  'gift.ranking.prize-name': 'Tên giải',
  'gift.ranking.weekly-quantity': 'Số quà mỗi tháng',
  'gift.ranking.quantity': 'Số lượng',
  'gift.ranking.type': 'Loại quà',
  'gift.ranking.type--artifact': 'Hiện vật',
  'gift.ranking.type--voucher': 'Voucher',

  'gift.ranking.button.transfer': 'Chuyển quà',
  'gift.ranking.button.sortOrder': 'Sắp xếp thứ tự giải thưởng',
  'gift.ranking.button.chooseGiftWinner': 'Chọn khách hàng nhận quà',
  'gift.confirm.delete': 'Bạn có xác nhận xóa quà này?',
  //add/edit page
  'gift.other.title': 'Danh sách quà khác',
  'gift.other.tab': 'Quà khác',

  'addGift.name': 'Thêm quà tặng',
  'addGift.ranking.title': 'Thêm quà tặng xếp hạng',
  'addGift.other.title': 'Thêm quà tặng khác',

  'updateGift.name': 'Cập nhật quà tặng',
  'updateGift.ranking.title': 'Cập nhật quà tặng xếp hạng',
  'updateGift.other.title': 'Cập nhật quà tặng khác',

  'addGift.form.type': 'Loại quà',
  'addGift.form.id': 'Mã quà tặng',
  'addGift.form.name': 'Tên quà tặng',
  'addGift.form.prize-name': 'Tên giải',
  'addGift.form.quantity': 'Tổng số lượng quà tặng',
  'addGift.form.weekly-quantity': 'Số lượng quà mỗi tháng',
  'addGift.form.image': 'Hình ảnh',
  //sort ranking gifts page
  'sortRankingGift.name': 'Sắp xếp thứ tự giải thưởng',
  'sortRankingGift.title': 'Sắp xếp thứ tự giải thưởng',

  'sortRankingGift.table.order': 'Thứ tự giải thưởng',
  'sortRankingGift.table.id': 'Mã quà tặng',
  'sortRankingGift.table.name': 'Tên quà tặng',
  'sortRankingGift.table.prize-name': 'Tên giải',
  'sortRankingGift.table.weekly-quantity': 'Số quà mỗi tháng',
  'sortRankingGift.table.quantity': 'Số lượng',
  'sortRankingGift.table.type': 'Loại quà',

  'sortRankingGift.move-top': 'Đẩy lên đầu',
  'sortRankingGift.move-bottom': 'Đẩy xuống cuối',
  'sortRankingGift.button.saveConfirm': 'Bạn có xác nhận lưu thay đổi?',
  'sortRankingGift.button.discardChange': 'Bạn có xác nhận hủy bỏ thay đổi?',

  //choose gift winner
  'giftGiving.title': 'Chọn người dùng phát quà',
  'giftGiving.table.title': 'Chọn người dùng phát quà',
  'giftGiving.display-table.title': 'Danh sách người nhận quà',

  'giftGiving.filter.cumulative-greenCoin': 'Green Coin tích lũy',
  'giftGiving.filter.week-ranking': 'Xếp hạng tháng',
  'giftGiving.filter.overall-ranking': 'Xếp hạng Overall',

  'giftGiving.name': 'Tên người dùng',
  'giftGiving.phoneNumber': 'Số điện thoại',
  'giftGiving.accumulatedCoins': 'Green coin tích lũy',
  'giftGiving.currentWeekRanking': 'Xếp hạng tháng',
  'giftGiving.selectedWeekRanking': 'Xếp hạng tháng',
  'giftGiving.overallRanking': 'Xếp hạng overall',
  'giftGiving.filter': 'Bộ lọc',
  'giftGiving.filterBy': 'Đang lọc theo',
  'giftGiving.week': 'tháng',
  'giftGiving.rank': 'hạng',
  'giftGiving.currentWeek': 'Tháng hiện tại',
  'giftGiving.rankingWeek': 'Chọn tháng xếp hạng',

  'giftGiving.button.deselect': 'Bỏ chọn',
  'giftGiving.button.reward': 'Tặng quà',
  'giftGiving.button.rewardConfirm': 'Bạn có xác nhận tặng quà?',
  //info page
  'giftInfo.name': 'Thông tin quà tặng',
  'giftInfo.ranking.gift.title': 'Thông tin quà tặng xếp hạng',
  'giftInfo.ranking.customer.title': 'Danh sách khách hàng nhận quà tặng xếp hạng',
  'giftInfo.other.gift.title': 'Thông tin quà khác',
  'giftInfo.other.customer.title': 'Danh sách khách hàng nhận quà khác',

  'giftInfo.card.id': 'Mã quà tặng',
  'giftInfo.card.name': 'Tên quà tặng',
  'giftInfo.card.type': 'Loại quà',
  'giftInfo.card.quantity': 'Tổng số lượng quà',
  'giftInfo.card.distributedQuantity': 'Số lượng quà đã phát',
  'giftInfo.card.undistributedGift': 'Số lượng quà chưa phát',
  'giftInfo.card.image': 'Hình ảnh',

  'giftInfo.table.name': 'Tên khách hàng',
  'giftInfo.table.phone': 'Số điện thoại',
  'giftInfo.table.giftSource': 'Nguồn quà tặng',
  'giftInfo.table.giftSource--award': 'Admin trao tặng',
  'giftInfo.table.giftSource--rank': 'Xếp hạng',
  'giftInfo.table.giftSource--bonus': 'Quà tặng kèm item',
  'giftInfo.table.rewardTime': 'Thời gian nhận thưởng',

  'giftInfo.table.rank': 'Xếp hạng',
  'giftInfo.table.ranking': 'Hạng',
  'giftInfo.table.week': 'Tháng xếp hạng',
  'giftInfo.table.greenCoin': 'Số Green Coin',

  //Voucher

  'voucher-import.title-Other': 'Thêm voucher cho quà tặng khác',
  'voucher-import.title-Ranking': 'Thêm voucher cho quà tặng xếp hạng',
  'modal-import.file': 'Chọn file',
  'modal-import.title': 'Nhập voucher cho quà tặng',
  'voucher-import.title': 'Quản lý voucher của',
  'modal-voucher-import.title': 'Nhập voucher',
  'voucher.router.name': 'Voucher quy đổi',
  //transfer gift
  'giftTransfer.modal.ranking.title': 'Chuyển quà tặng xếp hạng qua quà tặng khác',
  'giftTransfer.modal.other.title': 'Chuyển quà tặng khác qua quà tặng xếp hạng',

  'giftTransfer.modal.ranking.selectGift': 'Quà tặng khác cần nhận',
  'giftTransfer.modal.other.selectGift': 'Quà tặng xếp hạng cần nhận',
  'giftTransfer.modal.selectGift.placeholder': 'Chọn quà',
  'giftTransfer.modal.quantity': 'Tổng số lượng quà cần chuyển',
  'giftTransfer.modal.quantity.placeholder': 'Nhập số lượng',
  'giftTransfer.modal.button.addGift': 'Thêm quà',
  'giftTransfer.modal.button.transfer': 'Chuyển',
  'giftTransfer.modal.warn.sufficientAmount': 'Không đủ số lượng để chuyển',

  'gift-table.code': 'Mã voucher',
  'gift-table.operationStatus': 'Trạng thái hoạt động',

  'gift-import.title.update': 'Cập nhật trạng thái hoạt động',
  'gift-import.content.update': 'Bạn có chắc chắn muốn cập nhật những trạng thái đã chọn không?',
  'gift-import.title.delete': 'Xóa Voucher',
  'gift-import.content.delete': 'Bạn có chắc chắn muốn xóa voucher?',

  'gift-import-other.code': 'Mã voucher',
  'gift-import-other.shortLink': 'Link rút gọn',
  'gift-import-other.operationStatus': 'Trạng thái hoạt động',
  'gift-import-other.receivingTime': 'Thời gian nhận',
  'gift-import-other.createdAt': 'Thời gian thêm',
  'gift-import-other.receiveStatus': 'Trạng thái nhận',
  'gift-import-other.usageStatus': 'Trạng thái sử dụng',
  'gift-import-other.receiveStatus.params':
    '{status,select, 1 {Đã nhận} 2 {Chưa nhận} other {Không xác định}}',
  'gift-import-other.usageStatus.params':
    '{status,select, 1 {Đã sử dụng} 2 {Chưa sử dụng} other {Không xác định}}',

  'gift-import-other.Active': 'Đang hoạt động',
  'gift-import-other.Deactive': 'Dừng hoạt động',
  'gift-import-other.Received': 'Đã nhận',
  'gift-import-other.NotReceived': 'Chưa nhận',
  'gift-import-other.Used': 'Đã sử dụng',
  'gift-import-other.NotUsed': 'Chưa sử dụng',

  'gift-import-ranking.total': 'Tổng số mã voucher',
  'gift-import-ranking.totalReceived': 'Số mã voucher đã nhận',
  'gift-import-ranking.totalNotReceived': 'Số mã voucher chưa nhận',
  'gift-import-ranking.totalActive': 'Số mã voucher đang hoạt động',
  'gift-import-ranking.totalDeactive': 'Số mã voucher không hoạt động',

  'gift-import-ranking.code': 'Mã voucher',
  'gift-import-ranking.operationStatus': 'Trạng thái hoạt động',
  'gift-import-ranking.receivingTime': 'Thời gian nhận',
  'gift-import-ranking.createdAt': 'Thời gian thêm',
  'gift-import-ranking.receiveStatus': 'Trạng thái nhận',
  'gift-import-ranking.usageStatus': 'Trạng thái sử dụng',
  'gift-import-ranking.receiveStatus.params':
    '{status,select, 1 {Đã nhận} 2 {Chưa nhận} other {Không xác định}}',
  'gift-import-ranking.usageStatus.params':
    '{status,select, 1 {Đã sử dụng} 2 {Chưa sử dụng} other {Không xác định}}',
  'gift-import.edit': 'Chỉnh sửa trạng thái hoạt động',
  'gift-import-ranking.shortLink': 'Link rút gọn',
  'gift-table.shortLink': 'Link rút gọn',

  'gift-import.title.status.update': 'Cập nhật trạng thái hoạt động',
  'gift-import.content.status.update':
    'Bạn có chắc chắn muốn cập nhật những trạng thái đã chọn không?',

  'gift-import.title.warning': 'Không thể cập nhật voucher',
  'gift-import.content.warning':
    'Bạn đã chọn cả hai voucher đang hoạt động và dừng hoạt động nên không thể cập nhật',

  // update on 05/08
  'gift.upload-file': 'Tải lên file excel',
  'gift.add-child-gift': 'Thêm quà con',
  'giftGiving.currentMonthRank': 'Xếp hạng tháng',
};
